import { MatDialog, MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { ExerciseService } from 'app/shared/services/exercises.service';
import { Subject } from 'rxjs';
import { MpDialogComponent } from '../../theme/components/mp-dialog/mp-dialog.component';
import { VideoDialogComponent } from '../../theme/components/videoDialog/videoDialog.component';
var FavsComponent = (function () {
    function FavsComponent(dialog, exerciseService, translate, snackBar) {
        var _this = this;
        this.dialog = dialog;
        this.exerciseService = exerciseService;
        this.translate = translate;
        this.snackBar = snackBar;
        this.isKids = false;
        this.counter = 0;
        this.ngUnsubscribe = new Subject();
        this.exerciseService.getMyPrograms().then(function (programs) { return (_this.favs = programs); });
        this.exerciseService.getModules().then(function (modules) {
            if (modules) {
                var isKids = modules.some(function (mod) {
                    return mod.title.internal.includes('Kids');
                });
                _this.isKids = isKids;
            }
        });
    }
    FavsComponent.prototype.removeBox = function (p) {
        var _this = this;
        //Data-Synchronization needed to update MyPrograms
        this.exerciseService
            .deleteMyProgram(p)
            .then(function (result) {
            _this.exerciseService.getMyPrograms().then(function (programs) { return (_this.favs = programs); });
        })
            .catch(function (error) {
            console.log(error);
            _this.translate
                .get('EXERCISES.EDITOR.ALERT.removeError', { title: p.title })
                .takeUntil(_this.ngUnsubscribe)
                .subscribe(function (message) {
                var snackBarRef = _this.snackBar.open(message, null, {
                    verticalPosition: 'bottom',
                    duration: 4000,
                    panelClass: ['b2a-error', 'bottom'],
                });
            });
        });
    };
    FavsComponent.prototype.editBox = function (box) {
        this.openMpDialog(box);
    };
    FavsComponent.prototype.openMpDialog = function (editProgram) {
        var _this = this;
        var dialogRef = this.dialog.open(MpDialogComponent, {
            panelClass: 'app-MP-dialog-container',
            // width: '70vw',
            // height: '98vh',
            position: {
                top: '2vh',
            },
            data: editProgram || {},
        });
        dialogRef
            .afterClosed()
            .takeUntil(this.ngUnsubscribe)
            .subscribe(function (result) {
            _this.exerciseService.getMyPrograms().then(function (programs) { return (_this.favs = programs); });
        });
    };
    FavsComponent.prototype.openVideoDialog = function (p) {
        var dialogRef = this.dialog.open(VideoDialogComponent, {
            panelClass: 'app-video-dialog-container',
            // width: '60vw',
            maxWidth: '1600px',
            position: {
                top: '5vh',
            },
            data: { program: p },
        });
        dialogRef.afterClosed().takeUntil(this.ngUnsubscribe).subscribe();
    };
    /**
     * On destroy cancel active subscriptions
     */
    FavsComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    return FavsComponent;
}());
export { FavsComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/favs/favs.component.ts.pre-build-optimizer.js